import Reflux from "reflux";

var AssetLibraryActions = Reflux.createActions([
  "acceptAssetSelection",
  "selectAsset",
  "deleteAssets",

  "updateFilter",
  "updateSearch",
  "updateSort",

  "selectFolder",
  "showRenameFolder",
  "showCreateFolder",
  "showFolderChooser",
  "acceptMoveToFolder",

  "selectTab",

  "updateState", //general action for updating state properties in the store

  //Gallery List Actions
  "addSelectedToList",
  "addGalleryItems",
  "removeSelectedFromList",
  "reorderList",
  "selectListItem",
  "expandGallery",
  "contractGallery",
]);

export default AssetLibraryActions;
